import React, { memo, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { followSwitching } from '../../../Store/actions/channelActions';
import { reactHtmlParser } from '../../../common/common';
import LazyImage from '../../CustomLibraries/LazyImage';
import useShare from '../../customHooks/useShare';
import ShowMoreText from '../../showMoreText/ShowMoreText';
import useRedirect from '../../customHooks/useRedirect';

const ContributorCard = ({
  logo,
  title,
  description,
  channel_id,
  followed_status,
  privacy_status = 0,
  follower_count = 0,
  total_activity = 0,
  deeplink,
  specialities,
  onChangeFollowStatus,
  onViewMoreClick,
  onViewLessClick,
  isDescriptionExpanded,
  isAuthor = false,
  titleClick = null
}) => {
  console.log('isDescriptionExpanded', isDescriptionExpanded);
  const [disabled, setDisabled] = useState(true);
  const [btnText, setBtnText] = useState('');
  const [followerCounts, setFollowerCounts] = useState(0);
  useEffect(() => {
    setFollowerCounts(follower_count);
  }, [follower_count]);
  const disptach = useDispatch();
  const share_url = useShare();
  const checkButtonByFollowedStatus = (followed_status) => {
    if (followed_status == 1) {
      setBtnText('Access Requested');
      setDisabled(false);
    } else if (followed_status == 3) {
      setBtnText('Unfollow');
    } else if (followed_status == 0) {
      if (privacy_status == 1) {
        setBtnText('Request Access');
      } else {
        setBtnText('Follow');
      }
    }
  };

  const followSwitch = () => {
    if (disabled) {
      disptach(
        followSwitching(channel_id, (response) => {
          checkButtonByFollowedStatus(response.data);
          let convertedFollowedStatus = response.data;
          if (convertedFollowedStatus == 3) {
            setFollowerCounts(followerCounts + 1);
          } else if (convertedFollowedStatus == 0) {
            setFollowerCounts(followerCounts - 1);
          }
          onChangeFollowStatus && onChangeFollowStatus(convertedFollowedStatus);
        })
      );
    }
  };

  useEffect(() => {
    if (!!followed_status) {
      checkButtonByFollowedStatus(followed_status);
    }
  }, [followed_status]);

  const onShowMoreTextClick = () => {
    // alert('onShowMoreTextClick');
    if (isDescriptionExpanded) {
      onViewLessClick && onViewLessClick();
    } else {
      onViewMoreClick && onViewMoreClick();
    }
  };
  return (
    <div
      className={`w-100 overflow-hidden position-relative rounded-3 d-flex flex-column bg-extra-light clr_v3_ContributorCard`}
    >
      <div className="d-flex pe-sm-4 pe-3 justify-content-between align-items-center">
        <div className="ms-0 me-auto bg-soft-primary rounded-4 rounded-top-0 rounded-start-0 p-3 d-inline-flex gap-2 align-items-center position-relative z-2">
          <i className="flaticon-add-user fs-4"></i>
          {isAuthor ? 'Author' : 'Contributor'}
        </div>
        {specialities &&
          specialities.length > 0 &&
          specialities.map((speciality) => <span key={speciality.name}>{speciality.name}</span>)}
      </div>
      <div className="p-sm-4 p-3 pt-1 text-center d-flex flex-column gap-4">
        <div className="rounded-circle p-2 border border-2 border-primary position-relative mx-auto flex-shrink-0">
          {/* profile image full */}
          {isAuthor ? (
            <div className="overflow-hidden clr_v3_userImage-lg rounded-circle position-relative">
              <div className="w-100 h-100 position-relative">
                <img
                  src={logo}
                  width=""
                  height=""
                  alt="Dr. User Image"
                  className="object-fit-cover w-100 h-100 float-start"
                />
              </div>
            </div>
          ) : (
            <div
              className="overflow-hidden clr_v3_userImage-lg rounded-circle position-relative d-flex align-items-center justify-content-center p-2"
              onClick={() => titleClick && titleClick()}
            >
              <LazyImage
                src={logo}
                width=""
                height=""
                alt="Dr. User Image"
                extraClass="h-auto w-auto"
                className="w-auto h-auto mw-100 mh-100"
              />
            </div>
          )}
        </div>
        <div className="flex-grow-1 text-center flex-column d-flex">
          <h2
            className="fs-16 fw-semibold mb-2 text-black cursorPointer line-clamp-2"
            onClick={() => titleClick && titleClick()}
          >
            {title}
          </h2>
          <ShowMoreText
            anchorClass={'show-more-less-clickable text-nowrap cursorPointer d-block'}
            lines={3}
            expandByClick={false}
            onClick={onShowMoreTextClick}
            more={!isDescriptionExpanded ? 'View More' : 'View Less'}
            less={'View Less'}
            className="fs-4 mb-lg-0 mb-1"
          >
            {reactHtmlParser(description) || ''}
          </ShowMoreText>

          {/* <ul className="list-unstyled list-inline-item d-xl-none d-flex flex-wrap gap--sm-4 gap-3 m-0 justify-content-lg-center">
            {!!follower_count && (
              <li>
                <span className="fw-semibold me-1 text-black">{follower_count}</span>
                Followers
              </li>
            )}
            {!!total_activity && (
              <li>
                <span className="fw-semibold me-1 text-black">{total_activity}</span>
                Activities
              </li>
            )}
          </ul> */}

          <div className="d-flex w-100 align-items-center justify-content-between gap-4 mt-md-4 mt-3">
            {!!followerCounts && (
              <h2 className="text-primary fs-5  fw-normal lh-1">
                <span className="d-block fs-2 fw-semibold mb-1  ">{followerCounts}</span>
                Followers
              </h2>
            )}
            <div className="d-flex gap-2 flex-grow-1 justify-content-center">
              {!isAuthor && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="d-flex align-items-center gap-2 flex-grow-1 justify-content-center"
                  style={{ maxWidth: '160px' }}
                  onClick={followSwitch}
                >
                  <i className="flaticon-add-user"></i> {btnText}
                </Button>
              )}
              {!!deeplink && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="d-flex align-items-center gap-2"
                  onClick={() => share_url(title, deeplink)}
                >
                  <i className="flaticon-share-1"></i>
                </Button>
              )}
            </div>
            {!!total_activity && (
              <h2 className="text-primary fs-5 fw-normal lh-1">
                <span className="d-block fs-2 fw-semibold mb-1 text-primary ">
                  {total_activity}
                </span>
                Activities
              </h2>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ContributorCard);
